export const CLOUDFLARE_CAPTCHA_SITE_KEY = '0x4AAAAAAAzSTGqzFmL6s3aC';
